import { __ } from 'locale';
import React from 'react';
import Util from 'utility';

function taskRow(ok, key, children) {
    const spanClass = `flex w-[1.3em] h-[1.3em] shrink-0 border border-[#ccc] rounded-sm items-center justify-center ${ok ? 'bg-[#f6f9fd]' : 'bg-white'}`;
    const iClass = `fa fa-${ok ? 'check' : 'times'} text-[0.75em] ${ok ? 'text-[#8894a6]' : 'opacity-0'}`;
    return (
        <div key={key} className={`lecturetask-task flex m-0 mt-[5px] ${ok ? 'text-[#8894a6]' : ''}`}>
            <span className={spanClass}><i className={iClass}></i></span>
            <p className="m-0 ml-[0.5rem]">{children}</p>
        </div>
    );
}

function parseLimitSpec(n) {
    if (typeof n !== 'string' || n.trim() === '') return null;
    if (n.includes('-')) {
        const [a, b] = n.split('-');
        const min = a.replace(',', '.') * 1;
        const max = b.replace(',', '.') * 1;
        if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
        return { min, max, limitInfo: `${min}x - ${max}x ` };
    }
    const min = n * 1;
    if (!Number.isFinite(min)) return null;
    return { min, max: min, limitInfo: `${min}x ` };
}

function dddEntry(ok, isBelow, key, label, myValue, limitMin, limitMax, unit, attrOrder, onClickFn) {
    const u = unit ? ` ${unit}` : '';
    let content;
    if (ok) {
        content = <>{label}:{'\u00A0'}<span className="text-[0.85em] text-[#666]">{limitMin}{u}{'\u00A0'}-{'\u00A0'}{myValue}{'\u00A0'}-{'\u00A0'}{limitMax}{u}</span></>;
    } else {
        const limitsSpan = isBelow
            ? <span className="text-[0.85em] text-[#666]">{myValue}{'\u00A0'}-{'\u00A0'}{limitMin}{u}{'\u00A0'}-{'\u00A0'}{limitMax}{u}</span>
            : <span className="text-[0.85em] text-[#666]">{limitMin}{u}{'\u00A0'}-{'\u00A0'}{limitMax}{u}{'\u00A0'}-{'\u00A0'}{myValue}</span>;
        content = <a onClick={onClickFn}>{label}:{'\u00A0'}{limitsSpan}</a>;
    }
    return { element: taskRow(ok, key, content), order: attrOrder };
}

export default function evaluateTask(data, callbacks, parameters) {
    const lectureTaskAssistantDDD = () => {};

    const showTaskListDDDInfo = (taskListDDDInfo, id, type) => {
        if (typeof callbacks['dddInfo'] === 'function') {
            callbacks['dddInfo'](taskListDDDInfo, id, type);
        }
    };

    let _key = 0;
    const taskData = data.lectureTaskData;
    const lectureInfo = parameters.lectureInfo;

    let profileId = Util.getActiveProfileId();
    const baseProfileId = profileId;
    if (typeof data.appModeData.profileId === 'number') {
        profileId = data.appModeData.profileId;
    }

    let evalResults = false;
    let mealsResults = false;

    if (typeof data.evaluationResults === 'object') {
        evalResults = data.evaluationResults.results;
        mealsResults = data.mealsEvaluationResults;

        // This is hopefully only temporary - copy "my Profile ID" mealHashes to "admin-predefined Profile ID" mealHashes
        Object.keys(mealsResults).map(k => {
            const ka = k.split('|');
            if (typeof ka[1] === 'undefined') return;
            const newK = ka[0] + '|' + profileId;
            if (typeof mealsResults[newK] === 'undefined') {
                mealsResults[newK] = { ...mealsResults[k] };
            }
        });

    }

    if (typeof parameters.evaluationResults !== 'undefined') {
        evalResults = parameters.evaluationResults;
    }

    if (typeof parameters.mode !== 'undefined' && parameters.mode === 'meal') {
        mealsResults = {};
        mealsResults[parameters.mealHash] = evalResults;
    }

    let taskListMeals = [];
    let taskListMealsOk = [];
    let taskListUndesirableFoodsUsed = [];
    let taskListNumberOfFoods = [];
    let taskListNumberOfFoodsOk = [];
    let taskListDDD = [];
    let taskListDDDOk = [];
    let taskListDDDInfo = { 'categories': {}, 'tags': {} };

    // Meal types taste

    const tasteTitles = { 'sweet': 'sladká', 'salty': 'slaná' };
    if (Array.isArray(taskData.lecture_data.meal_types)) {
        taskData.lecture_data.meal_types.map(m => {
            if (m.type * 1 <= 0 || m.taste === '') return;

            let mealHash = m.type + '|' + profileId;
            if (typeof parameters.mealHash !== 'undefined' && parameters.mealHash !== mealHash) return;

            if (typeof data.foods[mealHash] === 'undefined') {
                let myOwnProfileId = 0;
                Object.keys(data.globals.profiles).map(pid => {
                    if (myOwnProfileId > 0) return;
                    const profile = data.globals.profiles[pid];
                    if (profile.id != profileId) myOwnProfileId = profile.id;
                });
                mealHash = m.type + '|' + myOwnProfileId;
            }

            let resultingTaste = 'sweet';
            let hasFoods = false;

            const checkTasteFoods = (hash) => {
                if (Array.isArray(data.foods[hash]) && data.foods[hash].length > 0) {
                    hasFoods = true;
                    data.foods[hash].map(f => {
                        if (data.globals.itemData[f.food_id].taste === 1) resultingTaste = 'salty';
                    });
                }
            };
            checkTasteFoods(mealHash);
            checkTasteFoods(m.type + '|' + Util.getFirstProfileId());

            const tasteOk = hasFoods && resultingTaste === m.taste;
            const label = <>{data.globals.mealTypes[m.type * 1].title}: {tasteTitles[m.taste]}</>;
            (tasteOk ? taskListMealsOk : taskListMeals).push(taskRow(tasteOk, _key++, label));
        });
    }

    // Meals setup (GI/GN/ST/TE/AC/EN)

    if (typeof evalResults !== 'undefined') {
        const keyToAttr = {
            'gi': 'gi', 'gn': 'gn', 'st': 'digestibility',
            'te': 'thermic_effect', 'ac': 'acidobasicity', 'en': 'energy',
        };

        var n = 0;
        taskData.lecture_data.meal_types.map(m => {
            if (m.type == 0) return;

            let mealHash = m.type + '|' + profileId;
            const ms = taskData.meal_types_setup[n];
            const mealName = data.globals.mealTypes[m.type].title;

            Object.keys(keyToAttr).map(k => {
                if (typeof mealsResults[mealHash] === 'undefined') return;

                const attr = keyToAttr[k];
                let value = mealsResults[mealHash][attr] * 1;
                if (!value) value = mealsResults[mealHash][attr + '_n'] * 1;
                if (isNaN(value)) value = 0;

                let valueLimited = value;
                const minRaw = ms[k].from;
                const maxRaw = ms[k].to;
                const min = +minRaw;
                const max = +maxRaw;

                let permittedValueText = <span>{min}-{max}</span>;
                let actualValueText = <span>{value}</span>;

                let evalK = attr;
                if (evalK === 'gn') evalK = 'gn_for_item';
                if (evalK === 'thermic_effect') evalK = 'thermiceffect';

                if (typeof data.globals.evaluationTexts[evalK] !== 'undefined') {
                    const t = data.globals.evaluationTexts[evalK];
                    if (typeof t[min] !== 'undefined') {
                        permittedValueText = <span>{t[min]}</span>;
                        if (evalK === 'gn_for_item') {
                            const tMin = t[min], tMax = t[max];
                            if (tMin !== tMax) permittedValueText = <span>{tMin} - {tMax}</span>;
                        }
                        const keysRange = Object.keys(t).map(n => n * 1);
                        if (valueLimited < Math.min(...keysRange)) valueLimited = Math.min(...keysRange);
                        if (valueLimited > Math.max(...keysRange)) valueLimited = Math.max(...keysRange);
                        actualValueText = <span>{t[valueLimited]}</span>;
                    } else {
                        let permittedValueTextArray = {};
                        Object.keys(t).map(rk => {
                            const range = rk.split(',');
                            range[0] = range[0] * 1;
                            range[1] = range[1] * 1;
                            if (min >= range[0] && min <= range[1]) {
                                permittedValueTextArray[t[rk]] = t[rk];
                                permittedValueText = t[rk];
                            }
                            if (max >= range[0] && max <= range[1]) permittedValueTextArray[t[rk]] = t[rk];
                            if (value >= range[0] && value <= range[1]) actualValueText = t[rk];
                        });
                        if (evalK === 'gn_for_item') {
                            const permKeys = Object.keys(permittedValueTextArray);
                            if (permKeys.length > 1) permittedValueText = permKeys.join(' - ');
                        }
                    }
                }

                let thisMealFoods = data.foods[mealHash];
                if (typeof thisMealFoods === 'undefined') {
                    thisMealFoods = data.foods[m.type + '|' + baseProfileId];
                    if (typeof thisMealFoods === 'undefined') {
                        const otherProfileId = Util.getOtherProfileId();
                        mealHash = m.type + '|' + otherProfileId;
                        thisMealFoods = data.foods[mealHash];
                    }
                }

                if (minRaw === '' || maxRaw === '') return;

                if (typeof thisMealFoods === 'undefined' || thisMealFoods.length == 0) {
                    taskListMeals.push(taskRow(false, _key++,
                        <>{mealName}: {data.globals.attributes[attr]}{'\u00A0'}({permittedValueText})</>
                    ));
                    return;
                }

                let valRealLimited = valueLimited;
                if (typeof data.globals.evaluationRealLimits[evalK] !== 'undefined') {
                    const rl = data.globals.evaluationRealLimits[evalK];
                    const realMin = Math.min(...rl);
                    const realMax = Math.max(...rl);
                    if (valRealLimited < realMin) valRealLimited = realMin;
                    if (valRealLimited > realMax) valRealLimited = realMax;
                }

                const valOk = valRealLimited >= min && valRealLimited <= max;
                if (valOk) {
                    taskListMealsOk.push(taskRow(true, _key++,
                        <>{mealName}: {data.globals.attributes[attr]}{'\u00A0'}({actualValueText})</>
                    ));
                } else {
                    taskListMeals.push(taskRow(false, _key++,
                        <>{mealName}: {data.globals.attributes[attr]}{'\u00A0'}({permittedValueText}, máte {actualValueText})</>
                    ));
                }
            });
            n++;
        });
    }

    // Meals - forbidden foods used?

    const undesirableFoods = lectureInfo.undesirable_foods;
    let undesirableFoodsInternalIds = [];

    if (typeof undesirableFoods === 'object') {
        Object.keys(data.foods).map(meal => {
            const m = meal.split('|')[0];
            if (typeof data.globals.mealTypes[m] === 'undefined') return;
            const mealName = data.globals.mealTypes[m].title;
            let mealOk = true;
            Object.keys(data.foods[meal]).map(f => {
                const food = data.foods[meal][f];
                if (undesirableFoods.includes(food.food_id)) {
                    undesirableFoodsInternalIds.push(food.id);
                    mealOk = false;
                }
            });

            if (!mealOk && !Util.isNutriKucharMode(data.appMode)) {
                const isMealMode = typeof parameters.mode !== 'undefined' && parameters.mode === 'meal';
                if (!isMealMode || meal === parameters.mealHash) {
                    taskListUndesirableFoodsUsed.push(taskRow(false, _key++,
                        <>{mealName}: {__('použity nepovolené potraviny')}</>
                    ));
                }
            }
        });
    }

    // Exact number of foods from individual categories

    if (Array.isArray(Object.keys(taskData.lecture_data.categories_foods_numbers))) {
        let foodInCategory = {};
        let mealAlreadyCounted = {};

        Object.keys(data.foods).map(meal => {
            Object.keys(data.foods[meal]).map(f => {
                const baseFood = data.foods[meal][f];
                let foodsArray = [baseFood.food_id];
                if (typeof data.globals.itemSubItems[baseFood.food_id] === 'object') {
                    foodsArray = [baseFood.food_id, ...data.globals.itemSubItems[baseFood.food_id]];
                }
                if (undesirableFoodsInternalIds.includes(baseFood.id)) return;

                foodsArray.map(foodId => {
                    const foodData = data.globals.itemData[foodId];
                    const categoryIds = data.globals.itemToCategory[foodId];
                    if (!foodData || !Array.isArray(categoryIds)) {
                        console.warn('TaskEvaluator: foodData or categoryIds not found for foodId', foodId);
                        return;
                    }
                    const food = { ...foodData, food_id: foodId };

                    categoryIds.map(cid => {
                        Object.keys(data.globals.categoryHierarchy).map(cid2 => {
                            if (!data.globals.categoryHierarchy[cid2].includes(cid)) return;

                            if (typeof foodInCategory[cid2] === 'undefined') foodInCategory[cid2] = 0;
                            const h = cid2 + '|' + meal;
                            if (typeof mealAlreadyCounted[h] === 'undefined') {
                                mealAlreadyCounted[h] = 1;
                                foodInCategory[cid2] += 1;
                            }

                            if (typeof taskListDDDInfo['categories'][cid2] === 'undefined') {
                                taskListDDDInfo['categories'][cid2] = [];
                            }
                            const ms = meal.split('|')[0];
                            taskListDDDInfo['categories'][cid2].push({
                                'food': food, 'baseFood': baseFood,
                                'meal': data.globals.mealTypes[ms].title, 'meal_id': ms
                            });
                        });
                    });
                });
            });
        });

        Object.keys(taskData.lecture_data.categories_foods_numbers).map(c => {
            const spec = parseLimitSpec(taskData.lecture_data.categories_foods_numbers[c]);
            if (!spec) return;

            let { min: limitMin, max: limitMax, limitInfo } = spec;
            let countOk = false;

            if (typeof foodInCategory[c * 1] !== 'undefined') {
                const fc = foodInCategory[c * 1] * 1;
                if (fc >= limitMin && fc <= limitMax) {
                    countOk = true;
                } else {
                    if (fc < limitMin) limitInfo = <span>{__('zbývá')} {limitMin - fc}x</span>;
                    if (fc > limitMax) limitInfo = <span>{__('přebývá')} {fc - limitMax}x</span>;
                }
            } else {
                if (limitMin === 0 && limitMax === 0) countOk = true;
            }

            const link = <a style={{ borderBottom: '1px dotted #aaa' }} onClick={(e) => showTaskListDDDInfo(taskListDDDInfo, c, 'category', e)}>{limitInfo}</a>;
            (countOk ? taskListNumberOfFoodsOk : taskListNumberOfFoods).push(
                taskRow(countOk, _key++, <>{data.globals.foodCategories[c * 1].title}: {link}</>)
            );
        });
    }

    // Exact number of foods from tags

    if (Array.isArray(Object.keys(taskData.lecture_data.tags_foods_numbers))) {
        let foodInTag = {};
        let foodTotalAmountInTag = {};
        let mealAlreadyCounted = {};
        let baseFoodsAlreadyAddedToDrink = [];

        Object.keys(data.foods).map(meal => {
            Object.keys(data.foods[meal]).map(f => {
                const baseFood = data.foods[meal][f];
                const baseFoodWeight = baseFood.weight * 1;
                let foodsArray = [baseFood.food_id];
                if (typeof data.globals.itemSubItems[baseFood.food_id] === 'object') {
                    foodsArray = [baseFood.food_id, ...data.globals.itemSubItems[baseFood.food_id]];
                }
                if (undesirableFoodsInternalIds.includes(baseFood.id)) return;

                foodsArray.map(foodId => {
                    const foodData = data.globals.itemData[foodId];
                    if (!foodData) {
                        console.warn('TaskEvaluator: foodData not found for foodId', foodId);
                        return;
                    }
                    const food = { ...foodData, food_id: foodId };

                    if (typeof data.globals.foodToTags[food.food_id] === 'undefined') return;

                    data.globals.foodToTags[food.food_id].map(tagId => {
                        if (typeof foodInTag[tagId] === 'undefined') foodInTag[tagId] = 0;

                        const h = tagId + '|' + meal;
                        if (typeof mealAlreadyCounted[h] === 'undefined') {
                            mealAlreadyCounted[h] = 1;
                            foodInTag[tagId] += 1;
                        }

                        if (typeof taskListDDDInfo['tags'][tagId] === 'undefined') {
                            taskListDDDInfo['tags'][tagId] = [];
                        }

                        const ms = meal.split('|')[0];
                        if (tagId !== 5 || baseFood.is_drink === 1) {
                            taskListDDDInfo['tags'][tagId].push({
                                'food': food, 'baseFood': baseFood,
                                'meal': data.globals.mealTypes[ms].title, 'meal_id': ms
                            });
                        }

                        if (typeof foodTotalAmountInTag[tagId] === 'undefined') foodTotalAmountInTag[tagId] = 0;
                        if (tagId === 5) {
                            if (baseFood.is_drink === 1 && !baseFoodsAlreadyAddedToDrink.includes(baseFood.id)) {
                                foodTotalAmountInTag[tagId] += baseFoodWeight;
                                baseFoodsAlreadyAddedToDrink.push(baseFood.id);
                            }
                        } else {
                            foodTotalAmountInTag[tagId] += food.weight * 1;
                        }
                    });
                });
            });
        });

        Object.keys(taskData.lecture_data.tags_foods_numbers).map(c => {
            const spec = parseLimitSpec(taskData.lecture_data.tags_foods_numbers[c]);
            if (!spec) return;

            let { min: limitMin, max: limitMax, limitInfo } = spec;
            if (c * 1 === 5 && limitMin !== limitMax) {
                limitInfo = `${limitMin} - ${limitMax} l`;
            }

            let countOk = false;

            if (typeof foodInTag[c * 1] !== 'undefined') {
                if (c * 1 === 5) {
                    const tv = foodTotalAmountInTag[c * 1];
                    const l1 = limitMin * 1000;
                    const l2 = limitMax * 1000;
                    if (tv >= l1 && tv <= l2) {
                        countOk = true;
                    } else {
                        if (tv < l1) limitInfo = <span>{__('zbývá')} {(l1 - tv) / 1000} l</span>;
                        if (tv > l2) limitInfo = <span>{__('přebývá')} {(tv - l2) / 1000} l</span>;
                    }
                } else {
                    const fc = foodInTag[c * 1] * 1;
                    if (fc >= limitMin && fc <= limitMax) {
                        countOk = true;
                    } else {
                        if (fc < limitMin) limitInfo = <span>{__('zbývá')} {limitMin - fc}x</span>;
                        if (fc > limitMax) limitInfo = <span>{__('přebývá')} {fc - limitMax}x</span>;
                    }
                }
            } else {
                if (limitMin === 0 && limitMax === 0) countOk = true;
            }

            const link = <a style={{ borderBottom: '1px dotted #aaa' }} onClick={(e) => showTaskListDDDInfo(taskListDDDInfo, c, 'tag', e)}>{limitInfo}</a>;
            (countOk ? taskListNumberOfFoodsOk : taskListNumberOfFoods).push(
                taskRow(countOk, _key++, <>{data.globals.foodTags[c * 1]}: {link}</>)
            );
        });
    }

    // DDD Limits

    let taskListDDDSorted = [];
    let taskListDDDSortedOk = [];

    if (typeof evalResults !== 'undefined') {
        if (Array.isArray(Object.keys(taskData.ddd_limits))) {
            Object.keys(taskData.ddd_limits).map(attr => {
                const limit = taskData.ddd_limits[attr];
                const eMin = limit[0] * 1;
                const eMax = limit[1] * 1;

                // ATTN: Terminology mismatch
                if (attr === 'fats_unsaturated') attr = 'fats_unsaturated_total';

                if (attr === 'kcal_kj') {
                    const kcal = evalResults['energy_kcal'];
                    const kj = evalResults['energy_kj'];
                    const evalOk = typeof kcal !== 'undefined' && kcal >= eMin && kcal <= eMax;
                    const isBelow = kcal < eMin;
                    const myKcal = <b>{Math.round(kcal * 100) / 100}</b>;
                    const myKj = <b>{Math.round(kj * 100) / 100}</b>;
                    const attrOrder = data.globals.attributes_order[attr];
                    const list = evalOk ? taskListDDDOk : taskListDDD;

                    list.push(dddEntry(evalOk, isBelow, _key++, data.globals.attributes['energy_kcal'], myKcal, eMin, eMax, '', attrOrder,
                        (e) => lectureTaskAssistantDDD(e, 'energy_kcal', !isBelow)));
                    list.push(dddEntry(evalOk, isBelow, _key++, data.globals.attributes['energy_kj'], myKj, Math.round(eMin * 4.18), Math.round(eMax * 4.18), '', attrOrder,
                        (e) => lectureTaskAssistantDDD(e, 'energy_kj', !isBelow)));
                    return;
                }

                if (typeof data.globals.attributes[attr] === 'undefined') return;

                const val = evalResults[attr];
                const evalOk = typeof val !== 'undefined' && val >= eMin && val <= eMax;
                const isBelow = val < eMin;
                const unit = data.globals.attribute_units[attr];
                const myValue = <b>{Math.round(val * 100) / 100} {unit}</b>;
                const attrOrder = data.globals.attributes_order[attr];

                (evalOk ? taskListDDDOk : taskListDDD).push(
                    dddEntry(evalOk, isBelow, _key++, data.globals.attributes[attr], myValue, eMin, eMax, unit, attrOrder,
                        (e) => lectureTaskAssistantDDD(e, attr, !isBelow))
                );
            });
        }
    }

    const byOrder = (a, b) => a.order === b.order ? 0 : a.order < b.order ? -1 : 1;
    taskListDDD.sort(byOrder);
    taskListDDDOk.sort(byOrder);
    taskListDDD.map(e => taskListDDDSorted.push(e.element));
    taskListDDDOk.map(e => taskListDDDSortedOk.push(e.element));

    return {
        'taskListMeals': taskListMeals,
        'taskListMealsOk': taskListMealsOk,
        'taskListUndesirableFoodsUsed': taskListUndesirableFoodsUsed,
        'taskListNumberOfFoods': taskListNumberOfFoods,
        'taskListNumberOfFoodsOk': taskListNumberOfFoodsOk,
        'taskListDDD': taskListDDDSorted,
        'taskListDDDOk': taskListDDDSortedOk,
        'taskListDDDInfo': taskListDDDInfo,
    };
}
